var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63338 9.05834C7.55005 9.05001 7.45005 9.05001 7.35838 9.05834C5.37505 8.99167 3.80005 7.36667 3.80005 5.36667C3.80005 3.32501 5.45005 1.66667 7.50005 1.66667C9.54172 1.66667 11.2 3.32501 11.2 5.36667C11.1917 7.36667 9.61671 8.99167 7.63338 9.05834Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.675 3.33333C15.2916 3.33333 16.5917 4.64166 16.5917 6.25C16.5917 7.825 15.3417 9.10833 13.7833 9.16666C13.7167 9.15833 13.6417 9.15833 13.5667 9.16666",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46672 12.1333C1.45006 13.4833 1.45006 15.6833 3.46672 17.025C5.75839 18.5583 9.51672 18.5583 11.8084 17.025C13.8251 15.675 13.8251 13.475 11.8084 12.1333C9.52506 10.6083 5.76672 10.6083 3.46672 12.1333Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2833 16.6667C15.8833 16.5417 16.45 16.3 16.9167 15.9417C18.2167 14.9667 18.2167 13.3583 16.9167 12.3833C16.4583 12.0333 15.9 11.8 15.3083 11.6667",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bc46257489d3e68fde9b5e17082fb060.svg";
export { ForwardRef as ReactComponent };